import { defineStore } from "pinia";
import Cookies from "js-cookie";
import { API_BASE_URL, CHECKTOKEN, GETNOTIFICATION, GETPRICES, } from "../utils/appConst";

const checkTokenUrl = `${API_BASE_URL}${CHECKTOKEN}`;
const getUnseenCount = `${API_BASE_URL}${GETNOTIFICATION}`;
const getPrices = `${API_BASE_URL}${GETPRICES}`;
interface AuthState {
  token: string | null;
  fcmToken: string | null;
  unseenCount: number | 0;
  permittedCookies: boolean | null;
  showCookiesFlag: boolean | null;
  authUsingGoogle: boolean | null;
  showAuthPop: boolean | null;
  products: Product[];
}

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { Product } from "../views/pricing.vue";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_apiKey,
  authDomain: import.meta.env.VITE_FIREBASE_authDomain,
  projectId: import.meta.env.VITE_FIREBASE_projectId,
  storageBucket: import.meta.env.VITE_FIREBASE_storageBucket,
  messagingSenderId: import.meta.env.VITE_FIREBASE_messagingSenderId,
  appId: import.meta.env.VITE_FIREBASE_appId,
  measurementId: import.meta.env.VITE_FIREBASE_measurementId,
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
getAnalytics(app);

const handleServiceWorkerMessage = (event: MessageEvent) => {
  useAuthStore().getUnseenCount();
  if (event.data && event.data.type === "notificationReceived") {
  }
};

if (navigator.serviceWorker) {
  navigator.serviceWorker
    .register(
      `./firebase-messaging-sw.js?${new URLSearchParams(
        firebaseConfig
      ).toString()}`
    )
    .then(function (registration) {
      console.log("server worker inited on scope: ", registration.scope);
    })
    .catch(console.log);
}

export const useAuthStore = defineStore("auth", {
  state: (): AuthState => ({
    token: null as string | null,
    fcmToken: null as string | null,
    unseenCount: 0,
    permittedCookies: null as boolean | null,
    showCookiesFlag: null as boolean | null,
    authUsingGoogle: null as boolean | null,
    showAuthPop: null as boolean | null,
    products: [
      {
        productId: '',
        price: 9,
        subscriptionType: "STARTER",
        stripe: true,
        isStudent: false,
      },
      {
        productId: '',
        price: 20,
        subscriptionType: "PRO",
        stripe: true,
        isStudent: false,
      },
      {
        productId: '',
        price: 35,
        subscriptionType: "PREMIUM",
        stripe: true,
        isStudent: false,
      }
    ],
  }),

  actions: {
    setToken(token: string): void {
      this.token = token;
      if (this.permittedCookies) {
        Cookies.set("authToken", token, { expires: 7 });
      }
    },

    setAuthPop(value: boolean): void {
      this.showAuthPop = value;
    },

    setUsingGoogleAuth(isGoogleAuth: boolean): void {
      this.authUsingGoogle = isGoogleAuth;
      if (Cookies.get("permittedCookies") === "true") {
        Cookies.set("authUsingGoogle", isGoogleAuth.toString(), { expires: 7 });
      }
    },

    checkUsingGoogleAuth(): void {
      if (Cookies.get("permittedCookies") === "true") {
        this.authUsingGoogle = Cookies.get("authUsingGoogle") === "true";
      } else {
        this.authUsingGoogle = false;
      }
    },

    setCookiesPermission(choice: boolean): void {
      this.permittedCookies = choice;
      const oneYearFromNow = new Date();
      oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
      Cookies.set("permittedCookies", choice.toString(), {
        expires: oneYearFromNow,
      });
    },

    getCookiesPermission(): void {
      const permittedCookies = Cookies.get("permittedCookies");

      this.showCookiesFlag =
        permittedCookies == null || permittedCookies === "false";
      this.permittedCookies = permittedCookies === "true";
    },

    incrementSeen(): void {
      this.unseenCount++;
      document.title = "(" + this.unseenCount + ") Subtitles tech";
    },

    decrementSeen(): void {
      if (this.unseenCount == 0) {
        return;
      }
      this.unseenCount--;
      if (this.unseenCount == 0) {
        document.title = "Subtitles tech";
      } else {
        document.title = "(" + this.unseenCount + ") Subtitles tech";
      }
    },

    logout(): void {
      try {
        this.token = null;
        if (this.permittedCookies) {
          Cookies.remove("authToken");
          Cookies.remove("authUsingGoogle");
        }
      } catch (error) {
        console.log(error);
      }
    },

    async initializeTokenFromCookies() {
      this.getCookiesPermission();
      const tokenFromCookies = Cookies.get("authToken");
      const fcmTokenPromise = this.initFCMToken();
      if (tokenFromCookies) {
        this.setToken(tokenFromCookies);
        const alive = await this.validateToken(tokenFromCookies);
        this.checkUsingGoogleAuth();
        if (!alive) {
          this.logout();
        }
      }
      await fcmTokenPromise;
      if (this.fcmToken && tokenFromCookies) {
        await this.validateToken(tokenFromCookies);
      }
    },

    async initFCMToken() {
      if (Notification.permission !== "denied") {
        try {
          try {
            // Retrieve the FCM token
            const currentToken = await getToken(messaging, {
              vapidKey: import.meta.env.VITE_VAPID_KEY,
            });
            if (currentToken) {
              this.fcmToken = currentToken;
              console.log("fcm token:", this.fcmToken);
            } else {
              console.log(
                "No registration token available. Request permission to generate one."
              );
            }
          } catch (tokenError) {
            console.log(
              "An error occurred while retrieving token: ",
              tokenError
            );
          }
          // Register message callback
          onMessage(messaging, (payload: any) => {
            this.incrementSeen();
            const data = payload?.data;
            if (data?.type === "ONETIME_AUDIO_UPLOAD" && data?.requestId) {
              window.dispatchEvent(
                new CustomEvent("oneTimePaymentSucceeded", {
                  detail: {
                    orderId: data.requestId,
                    orderSourceType: data.orderSourceType || "audio",
                  },
                })
              );
            }
            console.log(payload);
          });
        } catch (permissionError) {
          console.log(
            "An error occurred during permission request: ",
            permissionError
          );
        }
      }
    },

    async validateToken(token: string): Promise<boolean> {
      try {
        const response = await fetch(checkTokenUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "ngrok-skip-browser-warning": "69420",
          },
          body: JSON.stringify({
            fcmToken: this.fcmToken,
          }),
        });
        console.log(await response.json());

        if (response.ok) {
          await this.getUnseenCount();
          return true;
        } else {
          return false;
        }
      } catch (error) {
        console.error("Error validating token:", error);
        return false;
      }
    },
    async getUnseenCount() {
      try {
        if (this.token) {
          const response = await fetch(getUnseenCount, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.token}`,
              "ngrok-skip-browser-warning": "69420",
            },
          });
          if (response.ok) {
            const result = await response.json();
            if (result.message) {
              this.unseenCount = result.unseenNotificationsCount;
              if (this.unseenCount == 0) {
                document.title = "Subtitles tech";
              } else {
                document.title = "(" + this.unseenCount + ") Subtitles tech";
              }
            }
          }
        }
      } catch (error) {
        console.error("Error validating token:", error);
        return false;
      }
    },
    async fetchProductPrices() {
      try {
        const res = await fetch("https://www.cloudflare.com/cdn-cgi/trace");
        const text = await res.text();
        const match = text.match(/loc=(\w+)/);
        const countryCode = match ? match[1] : "US";
        const response = await fetch(getPrices + `?country=${countryCode}`, {
          method: "GET",
          headers: {
            "ngrok-skip-browser-warning": "69420",
          },
        });
        const result = await response.json();
        if (response.ok) {
          this.products = result.prices.map((item: any) => ({
            productId: item.productId,
            price: item.price,
            subscriptionType: item.subscriptionType,
            stripe: item.stripe,
            isStudent: item.isStudent,
          }));
          console.log("Correct fetching prices:", result.prices);
        } else {
          console.error("Error fetching prices:", result.error);
        }
      } catch (error) {
        console.error("Network error:", error);
      }
    },
  },
});
